import React, { Component } from 'react';
import PropTypes from 'prop-types';
import MenuItem from 'material-ui/MenuItem';
import { FormsySelect } from 'formsy-material-ui/lib';
import globals from '../../../../globals/communityGlobals';
import { MonthOption } from '../../../../enums/monthOption';
import DayOfMonthCalendar from '../shared/DayOfMonthCalendar';
import WeekOfMonthOption from '../shared/WeekOfMonthOption';
import { DaysOfWeek } from '../../../../enums/daysOfWeek';
import { WeeksOfMonth } from '../../../../enums/weeksOfMonth';

import { dropDownStyle, common } from '../../../../theme/AllocateBaseTheme';

const locale = globals.getAreas(['treatments', 'error']);

class DetailsMonthly extends Component {
  constructor(props) {
    super(props);
    this.state = {
      monthlyRecurrenceType: props.monthlyRecurrenceType,
    };
  }

  handleDayWeekSelect = (event, value) => {
    this.setState({
      monthlyRecurrenceType: value,
    });
  };

  generateMenuItems = () => {
    let monthlyOptions = [];
    monthlyOptions = Object.keys(MonthOption).map(key => (
      <MenuItem key={key} primaryText={MonthOption[key]} value={key} />
    ));

    return monthlyOptions;
  };

  render() {
    const { monthlyRecurrenceType, disabled } = this.props;
    return (
      <div className="row">
        <FormsySelect
          required
          requiredError={locale.getMsg('requiredFieldValidationMessage')}
          name="monthlyRecurrenceType"
          floatingLabelText={`${locale.getMsg('monthlyRecurrenceType')}*`}
          value={monthlyRecurrenceType}
          onChange={this.handleDayWeekSelect}
          floatingLabelStyle={common.floatingLabelStyle}
          floatingLabelShrinkStyle={common.floatingLabelShrinkStyle}
          floatingLabelFocusStyle={common.floatingLabelFocusStyle}
          underlineStyle={common.underlineStyle}
          style={dropDownStyle.style}
          errorStyle={common.errorStyle}
          iconStyle={dropDownStyle.iconStyle}
          labelStyle={dropDownStyle.labelStyle}
          menuStyle={dropDownStyle.menuStyle}
          disabled={disabled}
        >
          {this.generateMenuItems()}
        </FormsySelect>
        {MonthOption[this.state.monthlyRecurrenceType] === MonthOption.DayOfTheMonth ? (
          <DayOfMonthCalendar name="selectedDays" value={this.props.value} disabled={disabled} />
        ) : (
          <div className="col-c10">
            <WeekOfMonthOption
              key={'weekOfMonth'}
              name="selectedWeeks"
              options={WeeksOfMonth}
              value={this.props.selectedWeeks}
            />
            <WeekOfMonthOption
              key={'dayOfWeek'}
              name="selectedWeekDays"
              options={DaysOfWeek}
              value={this.props.selectedWeekDays}
            />
          </div>
        )}
      </div>
    );
  }
}

DetailsMonthly.defaultProps = {
  value: undefined,
  monthlyRecurrenceType: 'WeekOfTheMonth',
  selectedWeeks: ['First'],
  selectedWeekDays: ['Monday'],
};

DetailsMonthly.propTypes = {
  value: PropTypes.arrayOf(PropTypes.string),
  monthlyRecurrenceType: PropTypes.string,
  selectedWeeks: PropTypes.arrayOf(PropTypes.string),
  selectedWeekDays: PropTypes.arrayOf(PropTypes.string),
};

export default DetailsMonthly;
